import Vue from 'vue';
import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';

// https://github.com/sampotts/plyr#options
const mediaPlayerOptions = {
  controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen']
};
Vue.use(VuePlyr, { plyr: mediaPlayerOptions });
